import cn from 'classnames';
import styles from './HelpText.module.css';

type Props = {
  children: React.ReactNode;
  id?: string;
  /** A link to docs */
  helpHref?: string;
  className?: string;
};

/**
 * {@link HelpText} is intended to be used between a form label and the form control
 * to give context or instructions, possibly with a help link.
 */
export function HelpText({ children, id, helpHref, className }: Props) {
  return (
    <div id={id} className={cn('helptext', styles.HelpText, className)}>
      {children}{' '}
      {helpHref && (
        <a href={helpHref} className="a" target="_blank" rel="noreferrer">
          Read more.
        </a>
      )}
    </div>
  );
}
